import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hideSidebar } from '../../../redux/sidebar/actions';
import { setIsGreenlandSubscription } from '../../../redux/mailbox/actions';
import styles from './main.module.scss';
import { IRootState } from '../../../redux';
import { FixedLoader, ILayoutProps, MainContent, ScrollView, UserHeader, UserSidebar } from '../..';
import { ProfileSidebar } from '../ProfileSidebar/ProfileSidebar';
import ViewFolders from '../../ViewFolders/ViewFolders';
import { findMailboxRole, updateStorageMailIdFolderId } from '../../../helpers';
import { staticConfig } from '../../../config';
import { getMailboxRoles } from '../../../services';
import Exempted from '../Exempted/Exempted';
import { MailboxOwnerType } from '../../../enums';

export default function MainLayout(props: ILayoutProps) {
    const [isExempt, setIsExempt] = useState<boolean>(false);
    const { selectedMailboxId, isMailboxMounted, waitForUpdate, mediaSize, isBorger } = useReduxProps();
    const dispatch = useDispatch();
    const urlSearchParams = new URLSearchParams(window.location.search);

    const currentLocation = window.location.pathname;
    function onWrapClick(e: React.MouseEvent) {
        dispatch(hideSidebar());
    }

    useEffect(() => {
        const isFolderRedirect = urlSearchParams.get('isFolderRedirect');

        if (isFolderRedirect) {
            const folderRedirectParams = JSON.parse(decodeURIComponent(isFolderRedirect));
            updateStorageMailIdFolderId('redirectToFolder', folderRedirectParams);
        } else {
            updateStorageMailIdFolderId('folderTypeOwner');
        }

        const classicLogonPlace = localStorage.getItem('classicLogonPlace');
        const classicOverviewLink = staticConfig.classicOverviewLink.replace('{domainType}', classicLogonPlace);
        async function fetchData() {
            try {
                await fetch(
                    `${staticConfig.classicOverviewBaseLink}/${classicLogonPlace}/api_eb/users/publicauthorityinfo`,
                    {
                        method: 'GET',
                        credentials: 'include',
                        mode: 'cors',
                    }
                )
                    .then((response) => {
                        return response.json();
                    })
                    .then((userData) => {
                        if ((userData.Data.NgDP && userData.Data.NgDP.Status !== 'J') || !userData.Success) {
                            window.location.replace(classicOverviewLink);
                        }
                        dispatch(setIsGreenlandSubscription(userData.Data.Greenland.Registered));
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } catch (error) {
                console.log(error);
            }
        }

        fetchData();

        getMailboxRoles([403])
            .then((res) => {
                findMailboxRole(res.items).then((role) => {
                    if (role) {
                        role.exempt && setIsExempt(true);
                    } else {
                        setIsExempt(false);
                    }
                });
            })
            .catch((errors) => {
                setIsExempt(false);
            });
    }, []);

    return (
        <div className={['d-flex h-100 flex-column', styles.main].join(' ')}>
            <UserHeader isMailbox={isMailboxMounted} />
            {isExempt ? (
                <Exempted isBorger={isBorger} />
            ) : (
                <MainContent>
                    <div className="d-flex flex-row flex-fill flex-content-wrap">
                        <UserSidebar>
                            {currentLocation.includes('/settings/profile') ? (
                                <ProfileSidebar />
                            ) : (
                                selectedMailboxId && <ViewFolders isMailbox={isMailboxMounted} />
                            )}
                        </UserSidebar>
                        {/* <UserSidebar>{<ProfileSidebar/>}</UserSidebar> */}
                        <div className="h-100 w-100" onClick={onWrapClick}>
                            {props.disableCustomScroll ? (
                                <div className="h-100 overflow-hidden flex-fill">
                                    {waitForUpdate ? <FixedLoader size={mediaSize} /> : null}
                                    {props.children}
                                </div>
                            ) : (
                                <ScrollView>{props.children}</ScrollView>
                            )}
                        </div>
                    </div>
                </MainContent>
            )}
        </div>
    );
}

function useReduxProps() {
    const { selectedMailboxId, isMailboxMounted, waitForUpdate, mediaSize, isBorger } = useSelector(
        ({ mailbox, appReadouts }: IRootState) => {
            return {
                selectedMailboxId: mailbox.mailbox.id || localStorage.getItem('mailboxId'),
                isMailboxMounted: mailbox.isMailboxMounted,
                waitForUpdate: mailbox.waitForUpdate,
                mediaSize: appReadouts.mediaSize,
                isBorger: mailbox.mailbox.ownerType === MailboxOwnerType.CITIZEN,
            };
        }
    );

    return { selectedMailboxId, isMailboxMounted, waitForUpdate, mediaSize, isBorger };
}
